var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleInfoBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 24,
    viewBox: "0 0 10.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-battery-empty",
    "data-name": "Icon metro-battery-empty",
    d: "M28.54,20.169h-.923v.955a1.879,1.879,0,0,1-1.846,1.909H7.309a1.879,1.879,0,0,1-1.846-1.909V14.441a1.879,1.879,0,0,1,1.846-1.909H25.77a1.879,1.879,0,0,1,1.846,1.909V15.4h.923a.938.938,0,0,1,.923.955v2.864a.939.939,0,0,1-.923.955Zm-1.846-5.727a.938.938,0,0,0-.923-.955H7.309a.938.938,0,0,0-.923.955v6.682a.939.939,0,0,0,.923.955H25.77a.939.939,0,0,0,.923-.955Z",
    transform: "translate(-12.532 29.463) rotate(-90)",
    fill: "#e42125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInfoBattery);
export default __webpack_public_path__ + "static/media/vehicle-info-battery.59285ae6c37dc612321fe801eb09a7d8.svg";
export { ForwardRef as ReactComponent };